import React, { useState } from "react";
import bgimage from "../../assets/img/NokiaLogin.png";
import logo from "../../assets/img/NokiaLogo.png";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

export default function LoginScreen() {
  const { instance } = useMsal(); // Access MSAL instance from context

  const loginBtn = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
      console.log("Login successful", loginResponse);
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  return (
    <div
      // style={{ backgroundImage: `url(${bgimage})` }}
      className="relative min-h-screen bg-black overflow-hidden"
    >
      <img
        src={bgimage}
        alt="Background"
        className="absolute top-0 left-0 w-full h-full object-cover "
      />

      {/* Login Form */}
      <div className="relative z-10 flex items-center justify-center min-h-[calc(100vh-100px)] mt-8">
        <div
          style={{ border: "2px solid #5C93F6" }}
          className="bg-[#000000] rounded-2xl p-8 w-full max-w-md mx-4"
        >
          <div className="text-center mb-8">
            <img
              src={logo}
              alt="Logo"
              className="mx-auto mb-4 w-[276px] h-auto"
            />
            <h1 className="text-[32px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#FFFFFF] to-[#FFFFFF] mb-2">
              Welcome back!
            </h1>
            <p className="text-gray-300 text-[15px]">
              Create Your Account in Minutes
            </p>
          </div>

          <div className="space-y-6">
            <button
              onClick={loginBtn}
              style={{ border: "none" }}
              className="w-full bg-gradient-to-r from-[#005AFF] to-[#005AFF] text-white py-3 rounded-lg font-semibold hover:from[#005AFF]/50 hover:to-[#005AFF]/60 transition-all duration-200 transform hover:scale-105"
            >
              Sign In
            </button>

            <p className="text-center text-gray-300 text-sm">
              Don't have an account?{" "}
              {/* <a href="#" className="text-purple-400 hover:text-purple-300 transition-colors">
                Sign up here
              </a> */}
            </p>
          </div>
        </div>
      </div>

      {/* Bottom gradient bar */}
      <div className="absolute bottom-0 left-0 right-0 h-6 bg-gradient-to-r from-[#005AFF] to-[#005AFF]"></div>
    </div>
  );
}
